import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

function eventNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "event", next, x, y });
}

// 第6期は、局所的な合流と枝分かれが続く不規則な迷路。
export const MAP_NODES_CHOICE: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["f1"], x: 2, y: 0 }),
  f1: caseNode("f1", ["rest-f-open"], 2, 1),
  "rest-f-open": restNode("rest-f-open", ["f-l", "f-c", "f-r"], 2, 2),

  "f-l": caseNode("f-l", ["event-f-l"], 0, 3),
  "f-c": caseNode("f-c", ["f-cl", "f-cr"], 2, 3),
  "f-r": caseNode("f-r", ["f-r2"], 4, 3),
  "event-f-l": eventNode("event-f-l", ["f-l2"], 0, 4),
  "f-cl": caseNode("f-cl", ["rest-f-left"], 1, 4),
  "f-cr": caseNode("f-cr", ["f-c2"], 3, 4),
  "f-l2": caseNode("f-l2", ["rest-f-left"], 0, 5),
  "f-r2": caseNode("f-r2", ["event-f-r"], 4, 5),
  "rest-f-left": restNode("rest-f-left", ["f-l3"], 0, 6),
  "f-c2": caseNode("f-c2", ["rest-f-center"], 3, 6),
  "event-f-r": eventNode("event-f-r", ["f-r3"], 4, 6),
  "f-l3": caseNode("f-l3", ["f-l4"], 1, 7),
  "rest-f-center": restNode("rest-f-center", ["event-f-center", "f-xfer"], 2, 7),
  "f-r3": caseNode("f-r3", ["f-r4"], 4, 7),
  "f-l4": caseNode("f-l4", ["rest-f-left-late"], 0, 8),
  "event-f-center": eventNode("event-f-center", ["f-late-left"], 1, 8),
  "f-xfer": caseNode("f-xfer", ["f-late-right"], 3, 8),
  "rest-f-left-late": restNode("rest-f-left-late", ["rest-f-late"], 0, 9),
  "f-late-left": caseNode("f-late-left", ["rest-f-late"], 1, 9),
  "f-late-right": caseNode("f-late-right", ["rest-f-late"], 3, 9),
  "f-r4": caseNode("f-r4", ["rest-f-late"], 4, 9),

  "rest-f-late": restNode("rest-f-late", ["f-pre-left", "event-f-pre"], 2, 10),
  "f-pre-left": caseNode("f-pre-left", ["rest-f-pre"], 1, 11),
  "event-f-pre": eventNode("event-f-pre", ["f-pre-right"], 3, 11),
  "f-pre-right": caseNode("f-pre-right", ["rest-f-pre"], 3, 12),
  "rest-f-pre": restNode("rest-f-pre", ["boss"], 2, 13),
  boss: node("boss", { kind: "case", caseId: "choice-boss", next: [], x: 2, y: 14 }),
};
